module.exports = __webpack_public_path__ + "img/sys3.d3710647.png";